import { render } from "./AppReports.vue?vue&type=template&id=d4512388"
import script from "./AppReports.vue?vue&type=script&lang=js"
export * from "./AppReports.vue?vue&type=script&lang=js"

import exportComponent from "/home/dqlm/crypt/proj/eaxlabs_svn/fvemon/trunk/src/uiwww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__